import React, { PureComponent } from "react";
import _ from "lodash";
import { WithTitle, Slider, ProductItem } from "../components";
import { withRedux } from "../hoc";

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages"),
    product: _.get(state, "product")
  };
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class PopularProducts extends PureComponent {
  getData = () => {
    const { t } = this.props;
    let datas = _.get(this.props, "product.products.data");
    if (_.isEmpty(datas)) return datas;
    datas = _.filter(datas, data => t(_.get(data, "popular")) === true);
    return datas;
  };
  render() {
    const { t } = this.props;
    const datas = this.getData();
    if (_.size(datas) === 0) return null;
    return (
      <div className="popular-products-component with-title-with-slide">
        <WithTitle title={t("Popular Products")} backgroundColor="#d0021b">
          <Slider
            items={datas}
            uiRenderer={data => {
              return <ProductItem.Grid {...data} />;
            }}
            settings={{
              slidesToShow: 4
            }}
          />
        </WithTitle>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PopularProducts.js